import { createReducer, on } from "@ngrx/store";
import { addUsuarioAuth, addUsuarioAuthError, clearUsuarioAuth, updateUsuarioAuth } from "../actions/usuario-auth.actions";
import { initialUsuarioAuthState } from "../../core/interfaces/models/usuario-auth.interface";

export const usuarioAuthReducer = createReducer(
  initialUsuarioAuthState,
  on(addUsuarioAuth, (_, { usuarioAuthState }) => (
    usuarioAuthState
  )),
  on(addUsuarioAuthError, (state, { debugMessage }) => ({
    ...state,
    error: true,
    debugMessage
  })),
  on(updateUsuarioAuth, (state, { usuarioAuth }) => ({
    ...state,
    usuarioAuth: usuarioAuth
  })),
  on(clearUsuarioAuth, () => initialUsuarioAuthState)
);
